import React, { useContext, useEffect, useRef, useState, useTransition } from 'react';
import { useTranslation } from "react-i18next";
import Header from '../../components/header';

import {API, getCountries, host} from '../../services/api';
import jwtInterceoptor from '../../components/shared/jwtInterceptor';

import { date_formats } from '../../services/data';

import moment from 'moment';

import Swal from 'sweetalert2';
import GoBack from '../../components/goBack';
import OrgContext from '../../organisation/OrgContext';
import { useLocation, useNavigate } from 'react-router-dom';

function OrganisationUpdate(props) {

    const [t, i18n] = useTranslation();

    const {organisation, changeOrg} = useContext(OrgContext);

    const navigate = useNavigate();

    const location = useLocation();

    const {org} = location.state;

    moment.locale(i18n.language);

    const [countries, setCountries] = useState([]);
    const [activities, setActivities] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const [exercices, setExercices] = useState([]);
    const [dates, setDates] = useState(Array.from({length:31},(v,k)=>k+1));
    const [languages, setLanguages] = useState([]);
    const [timezones, setTimezones] = useState([]);
    const [formates, setDormates] = useState(date_formats);
    const [isSubmit, setIsSubmit] = useState(false);


    const LogoFile = useRef();
    const SignatureFile = useRef();
    const org_name = useRef("");
    const org_activity = useRef("");
    const org_address = useRef("");
    const org_addr_line1 = useRef("");
    const org_addr_line2 = useRef("");
    const org_ville = useRef("");
    const org_state = useRef("");
    const org_zip_code = useRef("");
    const org_tel = useRef("");
    const org_fax = useRef("");
    const org_web_site = useRef("");
    const org_email = useRef("");
    const org_currency = useRef("");
    const org_exercice = useRef("");
    const org_start_day = useRef("");
    const org_lang = useRef("");
    const org_timezone = useRef("");
    const org_date_format = useRef("");
    const ice = useRef('');
    const idf = useRef('');
    const rc = useRef('');
    const documentFooter = useRef('');
    const capital = useRef('');


    useEffect(()=>{

        console.log(`org::`, org);

        const fetchCountries = () => {
            getCountries()
            .then((data)=> setCountries(data))
            .catch((err) => console.error(err));
        };

        const fetchActivities = async () => {
            const response = await jwtInterceoptor.get("/data/activities");

            if(response.status === 200){
                setActivities(response.data.data);
            }
        };

        const fetchCurrencies = async () => {
            const response = await jwtInterceoptor.get("/data/currencies");

            if(response.status === 200){
                setCurrencies(response.data.data);
            }
        };

        const fetchExercices = async () => {
            const response = await jwtInterceoptor.get("/data/exercices");

            if(response.status === 200){
                setExercices([response.data.data[0]]);
            }
        };

        const fetchLanguages = async () => {
            const response = await jwtInterceoptor.get("/data/languages");

            if(response.status === 200){
                setLanguages(response.data.data);
            }
        };

        const fetchTimezones = async () => {
            const response = await jwtInterceoptor.get("/data/timezone");

            if(response.status === 200){
                setTimezones(response.data.data);
            }
        };

        fetchCountries();
        fetchActivities();
        fetchCurrencies();
        fetchExercices();
        fetchLanguages();
        fetchTimezones();

        org_name.current.value = org?.name;
        org_activity.current.value = org?.activity_id;
        org_address.current.value = org?.country_id;
        org_addr_line1.current.value = org?.address_line1;
        org_addr_line2.current.value = org?.address_line2;
        org_ville.current.value = org?.city;
        org_name.current.value = org?.name;
        org_state.current.value = org?.state;
        org_zip_code.current.value = org?.zip_code;
        org_tel.current.value = org?.phone;
        org_fax.current.value = org?.fax;
        org_web_site.current.value = org?.web_site;
        org_email.current.value = org?.email;
        org_currency.current.value = org?.currency_id;
        org_exercice.current.value = org?.exercice_id;
        org_start_day.current.value = org?.start_day;
        org_lang.current.value = org?.language_id;
        org_timezone.current.value = org?.timezone_id;
        org_date_format.current.value = org?.date_format;
        capital.current.value = org?.capital;

        if(org?.country_id == 144){

            setSectionDisplayForMorocco("block");
            setSectionDisplay("none");
            
            ice.current.value = org?.ice;
            idf.current.value = org?.if;
            rc.current.value = org?.rc;
           
            
        }else{
            setSectionDisplay("block");
            setSectionDisplayForMorocco("none");
            documentFooter.current.value = org?.documentFooter;
        }

    }, []);


    const [previewLogo, setPreviewLogo] = useState(null);
    const [sectionDisplayForMorocco,setSectionDisplayForMorocco] = useState('none');
    const [sectionDisplay,setSectionDisplay] = useState('none');

    const [previewSignature, setPreviewSignature] = useState(null);

    const onChangeLogo = (event) => {
        if(event.target?.files[0]){
            setPreviewLogo(event.target.files[0]);
        }
        
    }

    const onChangeSignature = (event) => {
        if(event.target?.files[0]){
            setPreviewSignature(event.target.files[0]);
        }
        
    }

    const submit = async (event) => {
        event.preventDefault();
        setIsSubmit(true);
        if(
            org_name.current.value.trim().length > 0 
            && org_activity.current.value.trim().length > 0
            && org_address.current.value.trim().length > 0
            && org_addr_line1.current.value.trim().length > 0
            && org_ville.current.value.trim().length > 0
            && org_state.current.value.trim().length > 0
            && org_zip_code.current.value.trim().length > 0
            && org_tel.current.value.trim().length > 0
            && org_currency.current.value.trim().length > 0
            && org_exercice.current.value.trim().length > 0
            && org_start_day.current.value.trim().length > 0
            && org_lang.current.value.trim().length > 0
            && org_timezone.current.value.trim().length > 0
            && org_date_format.current.value.trim().length > 0
        
            && ((org_address.current.value === "144") ? ice.current.value.trim().length > 0 : documentFooter.current.value.trim().length > 0)
        ){
            try {

                let formData = new FormData();

                if(previewLogo){
                    formData.append("logo", previewLogo);
                }

                if(previewSignature){
                    formData.append("signature", previewSignature);
                }
                
                formData.append("org_id", org?.id);
                formData.append("name", org_name.current.value);
                formData.append("activity_id", org_activity.current.value);
                formData.append("country_id", org_address.current.value);
                formData.append("exercice_id", org_exercice.current.value);
                formData.append("currency_id", org_currency.current.value);
                formData.append("language_id", org_lang.current.value);
                formData.append("timezone_id", org_timezone.current.value);
                formData.append("address_line1", org_addr_line1.current.value);
                formData.append("address_line2", org_addr_line2.current.value);
                formData.append("state", org_state.current.value);
                formData.append("city", org_ville.current.value);
                formData.append("zip_code", org_zip_code.current.value);
                formData.append("phone", org_tel.current.value);
                formData.append("web_site", org_web_site.current.value);
                formData.append("email", org_email.current.value);
                formData.append("fax", org_fax.current.value);
                formData.append("start_day", org_start_day.current.value);
                formData.append("date_format", org_date_format.current.value);
                formData.append("ice", ice.current.value);
                formData.append("if", idf.current.value);
                formData.append("rc", rc.current.value);
                formData.append("documentFooter", documentFooter.current.value);
                formData.append("capital", capital.current.value);

                const response = await jwtInterceoptor.post(
                    `/data/organisations/update`,
                    formData, 
                    {
                        headers: {
                        "Content-Type": "multipart/form-data",
                        }
                    }
                );

                if(response.status == 200){
                    if(response.data.status == true){
                        if(response.data.organisation){
                            const org_updated = response.data.organisation;
                            if(organisation?.id == org?.id){
                                changeOrg(org_updated);
                            }
                        }
                       
                        Swal.fire({
                            icon: 'success',
                            text: t(response.data.message),

                        });

                        navigate("/organisations/list");
                        window.location.reload();
                        return;
                    }else{
                        if(response.data?.data){
                            let messageError = "<ul>";
                            let keysErrors = Object.keys(response.data?.data);
                            keysErrors?.map((key) => {
                                messageError += `<li>${t(key)}: `;
                                messageError += t(response.data?.data[key][0]);
                                messageError += "</li>";
                            });
                            messageError += "</ul>";
                            Swal.fire({
                                icon: 'warning',
                                title: '',
                                html: messageError
                            });
                        }else {
                            Swal.fire({
                                icon: 'warning',
                                title: '',
                                text: t('Something went wrong!, try again'),
                            });
                        }
                        setIsSubmit(false);
                    }
                }else{
                    Swal.fire({
                        icon: 'warning',
                        title: '',
                        text: t('Something went wrong!, try again'),
                    });
                    setIsSubmit(false);
                }

                
            } catch (error) {
                Swal.fire({
                    icon: 'warning',
                    title: '',
                    text: t('Something went wrong!, try again'),
                });
                setIsSubmit(false);
            }
        }else{
            Swal.fire({
                icon: 'warning',
                title: '',
                text: t('Fill all fields'),
            });
            setIsSubmit(false);
        }
    }

    return (
        <>
            {organisation ? (
                <GoBack route='/organisations/list' />
            ): null}

            {organisation == null ? (
                <div className='row'>
                    <div className="col-xl-4 col-sm-12"></div>
                    <div className="col-xl-4 col-sm-12">
                        <div className="card border p-0 pb-3">
                            <div className="card-header border-0 pt-3">
                                <div className="card-options">
                                    <a href="javascript:void(0)" className="card-options-remove" data-bs-toggle="card-remove"><i className="fe fe-x"></i></a>
                                </div>
                            </div>
                            <div className="card-body text-center">
                                <span className=""><svg xmlns="http://www.w3.org/2000/svg" height="60" width="60" viewBox="0 0 24 24"><path fill="#fad383" d="M15.728,22H8.272a1.00014,1.00014,0,0,1-.707-.293l-5.272-5.272A1.00014,1.00014,0,0,1,2,15.728V8.272a1.00014,1.00014,0,0,1,.293-.707l5.272-5.272A1.00014,1.00014,0,0,1,8.272,2H15.728a1.00014,1.00014,0,0,1,.707.293l5.272,5.272A1.00014,1.00014,0,0,1,22,8.272V15.728a1.00014,1.00014,0,0,1-.293.707l-5.272,5.272A1.00014,1.00014,0,0,1,15.728,22Z"></path><circle cx="12" cy="16" r="1" fill="#f7b731"></circle><path fill="#f7b731" d="M12,13a1,1,0,0,1-1-1V8a1,1,0,0,1,2,0v4A1,1,0,0,1,12,13Z"></path></svg></span>
                                <h4 className="h4 mb-0 mt-3">{t("Alerte")}</h4>
                                <p className="card-text">{t("Est nécessaire d'ajouter une organisation pour continuer à utiliser votre application")}</p>
                            </div>
                        
                        </div>
                    </div>
                    <div className="col-xl-4 col-sm-12"></div>
                </div>
            ): null}
            
            <div className="card">
                <div className="card-header">
                    <h3 className="card-title">{t("Profil de l'organisation")}</h3>
                </div>
                <div className="card-body">
                    <div className='row'>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label className="form-label">{t("Votre logo")} (<span className="text-red">{t("Taille")} Max 1 Mo</span>) <span className="text-red">*</span></label>
                                <div className="dropify-wrapper" style={{height: 100.6}}>
                                    <div className="dropify-message">
                                        <span className="file-icon"> <p>{t("alert_drop")}</p></span>
                                        <p className="dropify-error">Ooops, something wrong appended.</p>
                                        </div><div className="dropify-loader"></div>
                                        <div className="dropify-errors-container"><ul></ul>
                                        </div>
                                        <input type="file" ref={LogoFile} className="dropify" onChange={onChangeLogo} data-height="180" /><button type="button" className="dropify-clear">Remove</button><div className="dropify-preview"><span className="dropify-render"></span><div className="dropify-infos"><div className="dropify-infos-inner"><p className="dropify-filename"><span className="dropify-filename-inner"></span></p><p className="dropify-infos-message">Drag and drop or click to replace</p></div></div></div></div>
                            </div>
                            {previewLogo?(<div>
                                <img src={URL.createObjectURL(previewLogo)} width={200} />
                            </div>): 
                            (
                                <div>
                                    <img src={`${host}/upload/logo/${org?.logo}`} width={200} />
                                </div>
                            )}
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label className="form-label">{t("Signature")} (<span className="text-red">{t("Taille")} Max 1 Mo</span>)</label>
                                <div className="dropify-wrapper" style={{height: 100.6}}>
                                    <div className="dropify-message">
                                        <span className="file-icon"> <p>{t("alert_drop")}</p></span>
                                        <p className="dropify-error">Ooops, something wrong appended.</p>
                                        </div><div className="dropify-loader"></div>
                                        <div className="dropify-errors-container"><ul></ul>
                                        </div>
                                        <input type="file" className="dropify" onChange={onChangeSignature} data-height="180" /><button type="button" className="dropify-clear">Remove</button><div className="dropify-preview"><span className="dropify-render"></span><div className="dropify-infos"><div className="dropify-infos-inner"><p className="dropify-filename"><span className="dropify-filename-inner"></span></p><p className="dropify-infos-message">Drag and drop or click to replace</p></div></div></div></div>
                            </div>
                            {previewSignature?(<div>
                                <img src={URL.createObjectURL(previewSignature)} width={200} />
                            </div>): 
                            (
                                <div>
                                    <img src={`${host}/upload/signature/${org?.signature}`} width={200} />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="row">

                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label className="form-label">{t("Nom de l'organisation")} <span className="text-red">*</span></label>
                                <input type="text" ref={org_name} className="form-control" placeholder={t("Nom de l'organisation")} />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label className="form-label">{t("Activité")} <span className="text-red">*</span></label>
                               
                                <select ref={org_activity} className="form-control form-select" placeholder={t("Activité")} >
                                    <option></option>
                                    { activities.map((a) => <option selected={org?.activity_id == a.id ? true : false} key={a.id} value={a.id}>{a.name}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label className="form-label">{t("Adresse de l'entreprise")} <span className="text-red">*</span></label>

                                <select
                                    onChange={(e) => {
                                        if (e.target.value === "144") {
                                            setSectionDisplayForMorocco("block");
                                            setSectionDisplay("none");
                                        }else{
                                            setSectionDisplay("block");
                                            setSectionDisplayForMorocco("none");
                                        }
                                    }}
                                        ref={org_address} className="form-control form-select" placeholder={t("Adresse de l'entreprise")} >
                                    <option></option>
                                    { countries.map((c) => <option selected={org?.country_id == c.id ? true : false} key={c.id} value={c.id}>{c.nicename}</option>)}
                                </select>
                            </div>

                        </div>
                    </div>
                    <div className="row" style={{"display":sectionDisplayForMorocco}}>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label className="form-label">{t("L'identifiant Commun de l'Entreprise")}*</label>
                                <input ref={ice} type="text" className="form-control" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label className="form-label">{t("L'identifiant Fiscal")} </label>
                                <input ref={idf}  type="text" className="form-control" />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label className="form-label">{t("L'immatriculation au Registre du Commerce")} </label>
                                <input ref={rc} type="text" className="form-control" />
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{"display":sectionDisplay}}>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label className="form-label">{t("L'bas de la page")}*</label>
                                <textarea ref={documentFooter}  className="form-control"></textarea>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="form-label">{t("Adresse de la société")} <span className="text-red">*</span></label>
                                <input ref={org_addr_line1} type="text" className="form-control" placeholder={t("Rue 1")} />
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="form-group">
                                <span className="text-red">*</span>
                                <input ref={org_addr_line2} type="text" className="form-control" placeholder={t("Rue 2")} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                            <span className="text-red">*</span>
                                <input ref={org_ville} type="text" className="form-control" placeholder={t("Ville")} />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                               
                                <input ref={org_state} type="text" className="form-control" placeholder={t("État/Province")} />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                            
                                <input ref={org_zip_code} type="text" className="form-control" placeholder={t("Code postal")} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        
                        
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                               
                                <input ref={org_tel} type="text" className="form-control" placeholder={t("Téléphone")} />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                            
                                <input ref={org_fax} type="text" className="form-control" placeholder={t("Fax")} />
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="form-group">
                               
                                <input ref={org_web_site} type="text" className="form-control" placeholder={t("Site Internet")} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label className="form-label">{t("Devise de base")} <span className="text-red">*</span></label>
                            
                                <select ref={org_currency} className="form-control form-select" placeholder={t("Devise de base")} >
                                    <option></option>
                                    { currencies.map((c) => <option selected={org?.currency_id == c.id ? true : false} key={c.id} value={c.id}>{c.code} - {c.name}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label className="form-label">{t("Email")}</label>

                                <input ref={org_email} type="email" className="form-control"
                                       placeholder={t("Email")}/>

                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label className="form-label">{t("Exercice")} <span
                                    className="text-red">*</span></label>

                                <select ref={org_exercice} className="form-control form-select"
                                        placeholder={t("Exercice")}>
                                    <option></option>
                                    {exercices.map((c) => <option selected={org?.exercice_id == c.id ? true : false}
                                                                  key={c.id} value={c.id}>{c.name}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-3">
                            <div className="form-group">
                                <label className="form-label">{t("Date de début")} <span
                                    className="text-red">*</span></label>

                                <select ref={org_start_day} className="form-control form-select"
                                        placeholder={t("Date de début")}>
                                    {dates.map((d) => <option key={d} value={d}>{d}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label className="form-label">{t("Langue")} <span className="text-red">*</span></label>

                                <select ref={org_lang} className="form-control form-select" placeholder={t("Langue")} >
                                    <option></option>
                                    { languages.map((c) => <option selected={org?.language_id == c.id ? true : false} key={c.id} value={c.id}>{c.name}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label className="form-label">{t("Fuseau horaire")} <span className="text-red">*</span></label>
                            
                                <select ref={org_timezone} className="form-control form-select" placeholder={t("Fuseau horaire")} >
                                    <option></option>
                                    { timezones.map((c) => <option selected={org?.timezone_id == c.id ? true : false} key={c.id} value={c.id}>(GMT {c.gmt_offset > -1 ? `+${c.gmt_offset}` : c.gmt_offset}) {c.timezone}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label className="form-label">{t("Format de la date")} <span className="text-red">*</span></label>
                            
                                <select ref={org_date_format} className="form-control form-select" placeholder={t("Format de la date")} >
                                <option></option>
                                    { formates.map((f) => <option key={f} value={f}>{f} [{moment().format(f)}]</option>)}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6 col-md-6">
                            <div className="form-group">
                                <label className="form-label">{t("Capital")}</label>
                                <input ref={capital} type="number" className="form-control" placeholder={t("Capital")} />
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className="card-footer">
                    <button disabled={isSubmit} type="button" onClick={submit}
                            className="btn btn-primary">{isSubmit ? t("Loading ...") : t("Enregistrer")}</button>
                </div>
            </div>
        </>
    );
}

export default OrganisationUpdate;